module.exports = {"430102001":"文艺路街道","430102002":"朝阳街街道","430102003":"韭菜园街道","430102008":"五里牌街道","430102009":"火星街道","430102010":"马王堆街道","430102011":"东屯渡街道","430102012":"湘湖街道","430102013":"定王台街道","430102014":"荷花园街道","430102015":"东岸街道","430102016":"马坡岭街道","430102017":"东湖街道","430102400":"隆平高科技园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430102.json
// module id = 1928
// module chunks = 0